import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../Loading/Loading';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isFornecedor, deveTrocarSenha, loading, user } = useAuth();
  const location = useLocation();

  // Paths permitidos para fornecedores
  const fornecedorAllowedPaths = ['/limeira', '/quadro-branco'];

  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Verificar se o usuário deve trocar a senha
  // Permite acesso à página de troca de senha
  if (user?.deveTrocarSenha && location.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace />;
  }

  // Se for fornecedor, verificar se está em uma rota permitida
  if (isFornecedor && isFornecedor()) {
    const isAllowed = fornecedorAllowedPaths.some(path => location.pathname.startsWith(path));

    if (!isAllowed) {
      // Redireciona para a primeira rota permitida (Limeira)
      return <Navigate to="/limeira" replace />;
    }
  }

  return children;
};

export default PrivateRoute;
